/**
 * The five order types, named in both scripts.
 *
 * The numbers are `Inv_Receipt_h.OrderType` as the whole stack writes them —
 * the same five the cashier's `orderTypeCodeFor` emits and the admin scopes a
 * promotion or coupon against (`apps/admin/src/features/promotions/shared.tsx`).
 * The names live here because a receipt is the first document that has to
 * PRINT one: a custom design binds `{{order_type}}` / `{{order_type_ar}}` and
 * nojoom_live's slip heads every ticket with "Delivery/توصيل".
 *
 * An unknown or null type resolves to an empty string in BOTH scripts, so a
 * design that binds it with `hideIfEmpty` (or inside an [[optional segment]])
 * simply prints nothing. Guessing "Takeaway" for a legacy receipt that never
 * recorded a type would put a wrong word on a customer's paper.
 */
const ORDER_TYPE_NAMES: Record<number, { en: string; ar: string }> = {
  1: { en: 'Takeaway', ar: 'سفري' },
  2: { en: 'Delivery', ar: 'توصيل' },
  3: { en: 'Dine-in', ar: 'صالة' },
  4: { en: 'Pickup', ar: 'استلام' },
  5: { en: 'Membership', ar: 'عضوية' },
};

export function orderTypeNameEn(code: number | null | undefined): string {
  return code == null ? '' : ORDER_TYPE_NAMES[code]?.en ?? '';
}

export function orderTypeNameAr(code: number | null | undefined): string {
  return code == null ? '' : ORDER_TYPE_NAMES[code]?.ar ?? '';
}
